import { AnalysisSettings } from 'features/analysis/types'

export enum FilterNumber {
  Between = 'between',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  Equal = 'equal',
  LessThanOrEqual = 'lessThanOrEqual',
  GreaterThanOrEqual = 'greaterThanOrEqual'
}

export enum FilterText {
  Equal = 'equal',
  Different = 'different'
}

export enum FilterTypes {
  Number = 'number',
  Text = 'text'
}

export interface Filter {
  name: string
}

export interface Column {
  name: string
  type: string
}

export interface FilterByColumnSettings extends AnalysisSettings {
  sourceColumn: string
  filterType?: FilterTypes
  filterNumberType?: FilterNumber
  filterTextType?: FilterText
  filterValue?: string[] | number[]
  filterNumberFirst?: number
  filterNumberSecond?: number
}
